import { GetManyResponse, GetOneResponse } from 'core/types';
import { objectKeysSnakeCaseToCamelCase } from 'core/utils';

export const mapRecordsFromServer = <T, EDT = any>(
  data: T[],
  recordsFiltered?: number,
  totals?: Record<string, unknown>,
  extraData?: EDT,
  hasMore?: boolean
): GetManyResponse<T, EDT> => {
  return {
    records: objectKeysSnakeCaseToCamelCase(data),
    count: recordsFiltered,
    hasMore,
    totals: objectKeysSnakeCaseToCamelCase(totals),
    extraData: objectKeysSnakeCaseToCamelCase(extraData),
  };
};

export const mapRecordFromServer = <T, EDT = any>(
  data: T[],
  success?: boolean,
  extraData?: EDT
): GetOneResponse<T, EDT> => {
  const record = data?.length === 0 ? null : objectKeysSnakeCaseToCamelCase(data);

  return {
    record,
    extraData: objectKeysSnakeCaseToCamelCase(extraData),
    success,
  };
};
